import { PopoverPlacement } from "@idui/react-popover";
import { InfoOutlined } from "@mui/icons-material";
import { FormControlLabel, Radio } from "@mui/material";
import { FC, ReactNode } from "react";

import { RebuildRouteTypeEnum, useIsMobile } from "@ryde/shared";

import { FramerTooltip } from "../tooltips";
import { REBUILD_ROUTE_DROPDOWN_INFO_TOOLTIP_MOUSE_ENTER_DELAY_MS } from "./rebuild-route-dropdown.constants";

interface IRebuildRouteDropdownRadioOptionProps {
  value: RebuildRouteTypeEnum;
  label: ReactNode;
  tooltip: string;
}

export const RebuildRouteDropdownRadioOption: FC<
  IRebuildRouteDropdownRadioOptionProps
> = ({ value, label, tooltip }) => {
  const { isMobile } = useIsMobile();

  return (
    <div className="rebuild-route-dropdown-radio-row">
      <FormControlLabel
        value={value}
        control={<Radio size="small" />}
        label={label}
        className="rebuild-route-dropdown-radio-item"
      />
      {!isMobile && (
        <FramerTooltip
          content={tooltip}
          placement={PopoverPlacement.top}
          mouseEnterDelay={
            REBUILD_ROUTE_DROPDOWN_INFO_TOOLTIP_MOUSE_ENTER_DELAY_MS
          }
        >
          <button
            type="button"
            className="rebuild-route-dropdown-skip-cache-info"
            aria-label={tooltip}
          >
            <InfoOutlined fontSize="inherit" />
          </button>
        </FramerTooltip>
      )}
    </div>
  );
};
